import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IGroup } from '@principle-theorem/shared';

interface IToolCard {
  name: string;
  description: string;
  routerLink: string[];
}

function sortByName(a: IToolCard, b: IToolCard): number {
  return a.name.localeCompare(b.name);
}

@Component({
  selector: 'pr-tools',
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToolsComponent {
  groups: IGroup<IToolCard, string>[] = [
    {
      group: 'Support',
      items: [
        {
          name: 'Auth User Lookup',
          description: 'Look up users by email and view their auth status.',
          routerLink: ['./auth-user-lookup'],
        },
        {
          name: 'Seed Demo Space',
          description: 'Create seed data for production and demo workspaces.',
          routerLink: ['./seed-demo-space'],
        },
      ].sort(sortByName),
    },
    {
      group: 'Maintenance',
      items: [
        {
          name: 'Typesense',
          description:
            'Seed API keys and sync Typesense resources for organisations.',
          routerLink: ['./typesense'],
        },
        {
          name: 'Migration Runner',
          description: 'Run database migrations that rely on Angular services.',
          routerLink: ['./migration-runner'],
        },
        {
          name: 'BigQuery Jobs',
          description:
            'Create and monitor BigQuery sync jobs for organisations.',
          routerLink: ['./big-query-jobs'],
        },

        {
          name: 'Revoke Auth Sessions',
          description:
            'Force all users to re-authenticate by logging in again. Use after auth-affecting updates.',
          routerLink: ['./revoke-auth-sessions'],
        },
      ].sort(sortByName),
    },
    {
      group: 'Monitoring',
      items: [
        {
          name: 'View Reporting Datapoints',
          description:
            'View the raw datapoints that are being sent to the reporting system, to help with debugging and understanding what data is available.',
          routerLink: ['./reporting'],
        },
        {
          name: 'BigQuery Uploads Monitor',
          description:
            'Monitor the status of BigQuery uploads and view any errors that have occurred.',
          routerLink: ['./big-query-uploads', 'stats'],
        },
        {
          name: 'Management API Log',
          description:
            'View audit log of management API actions performed by staff.',
          routerLink: ['./api-log'],
        },
      ].sort(sortByName),
    },
    {
      group: 'AI Tools',
      items: [
        {
          name: 'AI Scribe',
          description: 'Upload test recordings and manage AI Scribe demo data.',
          routerLink: ['./ai-scribe'],
        },
      ].sort(sortByName),
    },
  ];
}
